import PropTypes from 'prop-types';

import { formatPrice } from '~/utils';

import { BookingReference } from '../booking-header/booking-reference';

import styles from '../BookingReview.scss';

export const AppointmentBookingHeader = ({
  department: { name: departmentName },
  appointmentType: { name: appointmentTypeName },
  price,
  bookingId,
  departmentTitle = null,
}) => (
  <header className={styles.AppointmentBookingReview__header} data-testid="appointmentHeader">
    <div className={styles.AppointmentBookingReview__headers}>
      <h1 className={styles.AppointmentBookingReview__header__service}>
        {departmentTitle || departmentName}
      </h1>
      <h1 className={styles.AppointmentBookingReview__type__appointment}>{appointmentTypeName}</h1>
    </div>
    <div className={styles.AppointmentBookingReview__info}>
      <BookingReference id={bookingId} />
      <span className={styles.AppointmentBookingReview__price}>{formatPrice(price)}</span>
    </div>
  </header>
);

AppointmentBookingHeader.propTypes = {
  department: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  appointmentType: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  price: PropTypes.string.isRequired,
  bookingId: PropTypes.string.isRequired,
  departmentTitle: PropTypes.string,
};
